import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { schoolSettingsApi } from 'services/apiDigitalTicket/schoolSettings';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as SchoolSettingsActions from './actions';

import { SchoolSettingsTypes } from './types';

function* get({
  payload,
}: ReturnType<typeof SchoolSettingsActions.getSchoolSettingsRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schoolSettingsApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchoolSettingsActions.getSchoolSettingsSuccess({
          schoolSettingsData: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schoolSettings - getschoolSettings - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchoolSettingsActions.getSchoolSettingsFailure());
    yield put(DialogsActions.setClose());
  }
}

function* update({
  payload,
}: ReturnType<typeof SchoolSettingsActions.updateSchoolSettingsRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schoolSettingsApi.update, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchoolSettingsActions.updateSchoolSettingsSuccess({
          schoolSettingsData: response.data,
        }),
      );

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Instituições atualizadas com sucesso.',
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schoolSettings - updateSchoolSettings - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchoolSettingsActions.updateSchoolSettingsFailure());
    yield put(DialogsActions.setClose());
  }
}

function* updateIndividual({
  payload,
}: ReturnType<
  typeof SchoolSettingsActions.updateSchoolSettingsIndividualRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    let arr = payload;
    if (Array.isArray(payload)) {
      arr = payload.map((item) => ({
        ...item,
        transportOperatorId: transportOperator.id,
      }));
    }
    const response = yield call(schoolSettingsApi.updateIndividual, {
      data: [...arr],
    });

    if (response.status === 200) {
      yield put(
        SchoolSettingsActions.updateSchoolSettingsIndividualSuccess({
          schoolSettingsData: response.data,
        }),
      );

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Instituições atualizadas com sucesso.',
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error(
      'schoolSettings - updateSchoolSettingsIndividual - error',
      error,
    );

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchoolSettingsActions.updateSchoolSettingsIndividualFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const schoolSettingsSagas = [
  takeLatest(SchoolSettingsTypes.GET_SCHOOL_SETTINGS_REQUEST, get),
  takeLatest(SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_REQUEST, update),
  takeLatest(
    SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_REQUEST,
    updateIndividual,
  ),
];
